
export default class LoaclStorage {

    static _keySuffix : string = ""

    //异步存储 微信专用 注意需要实时读取的不要用
    static setStorageNumber(key: string, data: number) {
        LoaclStorage.setNumber(key, data)
    }

    static setStorageString(key: string, data: string) {
        LoaclStorage.setString(key, data)
    }

    static setStorage(key: string, data: any) {
        LoaclStorage.setItem(key, data)
    }

    static setNumber(key: string, data: number, appendKeySuffix ?: boolean) {
        try {
            key = appendKeySuffix ? key + LoaclStorage._keySuffix : key 
            localStorage.setItem(key, data.toString());
        } catch (error) {
            cc.warn(key, error)
        }
    }

    static getNumber(key: string, defaultValue?: number, appendKeySuffix ?: boolean) : number {
        try {
            key = appendKeySuffix ? key + LoaclStorage._keySuffix : key 
            var value : any = localStorage.getItem(key);
            //这里有一个坑 key不存在时返回的是 字符串“null”
            if (!value || value == "null" || value == "NaN") {
                if (defaultValue != null) {
                    return defaultValue;
                }
                return null;
            }
            return value;
        } catch (error) {
            cc.warn(key, error)
        }
    }

    static setJson(key: string, data: JSON, appendKeySuffix ?: boolean) {
        try {
            key = appendKeySuffix ? key + LoaclStorage._keySuffix : key 
            localStorage.setItem(key, JSON.stringify(data));
        } catch (error) {
            cc.warn(key, error)
        }
    }

    static getJson(key: string, appendKeySuffix ?: boolean) {
        try {
            key = appendKeySuffix ? key + LoaclStorage._keySuffix : key 
            var str = localStorage.getItem(key);
            if (!str || str == "" || str == "null") {
                return null;
            }
            var data = JSON.parse(str);
            return data;
        } catch (error) {
            cc.warn(key, error)
        }
    }

    static setString(key: string, data: String, appendKeySuffix ?: boolean) {
        try {
            key = appendKeySuffix ? key + LoaclStorage._keySuffix : key 
            localStorage.setItem(key, data.toString());
        } catch (error) {
            cc.warn(key, error)
        }
    }

    static getString(key: string, defaultValue?: string, appendKeySuffix ?: boolean): string {
        try {
            key = appendKeySuffix ? key + LoaclStorage._keySuffix : key 
            var str = localStorage.getItem(key);
            if (!str || str == ""|| str == "null") {
                if (defaultValue != null) {
                    return defaultValue;
                }
                return null;
            }
            return str;
        } catch (error) {
            cc.warn(key, error)
        }
    }

    static setItem(key: string, data: any) {
        try {
            localStorage.setItem(key, data);
        } catch (error) {
            cc.warn(key, error)
        }
    }

    static getItem(key: string): any {
        try {
            var str = localStorage.getItem(key);
            if (!str || str == "null") {
                return null;
            }
            return str;
        } catch (error) {
            cc.warn(key, error)
        }
    }

    static hasItem(key: string) {
        var str = localStorage.getItem(key);
        return str != null;
    }

    static delete(key: string) {
        //var str = cc.sys.localStorage.setItem(key, null);        
        localStorage.removeItem(key);
    }

    static clear(){
        localStorage.clear()
    }

    static setSuffix(key1, key2) {
        LoaclStorage._keySuffix = `_${key1}_${key2}`
    }
}
